// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11jHU","footer":"styles_footer__VxVhk","passCodeTooltip":"styles_passCodeTooltip__35p6Z"};